import {
    getNotificationsLoading,
    getNotificationsReject,
    getNotificationsRequest,
    getNotificationsSuccess
} from "../../actions/notifications/getAll";

export const getNotifications = (formData) => async (dispatch, getState) => {
    dispatch(getNotificationsLoading());
    try {
        const { data } = await getNotificationsRequest(formData, getState);
        dispatch(getNotificationsSuccess(data))
    } catch (error) {
        dispatch(getNotificationsReject(error))
    }
    return Promise.resolve();
};